import Vue from 'vue';
import Vuex from 'vuex';
import AudioBook from './modules/AudioBook';
import Chapter from './modules/Chapter';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        AudioBook,
        Chapter
    }
});